/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleADownIcon20Regular = forwardRef('ArrowShapeTriangleADownIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.62 6a1.35 1.35 0 0 1 1.118 2.106l-4.62 6.83a1.35 1.35 0 0 1-2.236 0l-4.62-6.83A1.35 1.35 0 0 1 5.38 6h9.24Zm-.283 1.5H5.663L10 13.912 14.337 7.5Z" })));
});
